import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";
import { CROSS_SELL_POPUP_URL } from "../index";

export const ExpandedWarrantyOnboarding = memo(
  function ExpandedWarrantyOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const handleAction = () => {
      window.open(`${CROSS_SELL_POPUP_URL}/ew-one-pager.pdf`, "_blank");
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText="Learn more"
        description="Check out our new extended warranties capabilities."
        image={`${CROSS_SELL_POPUP_URL}/ew-popup.png`}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Extended Warranties now available!"
      />
    );
  },
);
